// -----------------------------------------------------------------------------
// PushToTalkButton.jsx
// Brand-aligned push-to-talk microphone for Harbour Nest.
//
// PURPOSE:
// - Primary voice input control
// - Circular, floating-friendly design
// - Strict brand compliance (white / #CC0202 only)
//
// INTERACTION MODEL:
// - Press and hold → listening
// - Release → processing
// -----------------------------------------------------------------------------

import React from "react";
import useVoiceAssistant from "./useVoiceAssistant.js";

export default function PushToTalkButton() {
  const { status, startListening, stopListening } = useVoiceAssistant();

  const isListening = status === "listening";
  const isProcessing = status === "processing";

  return (
    <div className="relative flex items-center justify-center">
      {/* ---------------------------------------------------------
         BRAND RING (LISTENING / PROCESSING)
      --------------------------------------------------------- */}
      {(isListening || isProcessing) && (
        <div
          className={`
            absolute
            w-14 h-14
            rounded-full
            border-2
            ${isListening ? "animate-hn-pulse" : "animate-hn-spin"}
          `}
          style={{
            borderColor: isListening
              ? "rgba(204, 2, 2, 0.35)"
              : "#CC0202",
          }}
        />
      )}

      {/* ---------------------------------------------------------
         MIC BUTTON (CIRCULAR, BRAND)
      --------------------------------------------------------- */}
      <button
        type="button"
        aria-pressed={isListening}
        onMouseDown={startListening}
        onMouseUp={stopListening}
        onMouseLeave={stopListening}
        onTouchStart={startListening}
        onTouchEnd={stopListening}
        className="
          w-12 h-12
          rounded-full
          flex items-center justify-center
          text-lg
          transition
          shadow-sm
          select-none
        "
        style={{
          backgroundColor: isListening || isProcessing ? "#CC0202" : "#ffffff",
          color: isListening || isProcessing ? "#ffffff" : "#CC0202",
          border: "2px solid #CC0202",
        }}
      >
        🎤
      </button>
    </div>
  );
}
